import React, { useState } from 'react';
import { Box } from '@mui/material';
import SignIn from '../components/SignIn';
import SignUp from '../components/SignUp';

const AuthPage: React.FC = () => {
    const [isSignIn, setIsSignIn] = useState(true);

    const handleSwitchToSignUp = () => {
        setIsSignIn(false);
    };

    const handleSwitchToSignIn = () => {
        setIsSignIn(true);
    };

    return (
        <Box
            sx={{
                bgcolor: 'background.default',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                width: '100%',
            }}
        >
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {isSignIn ? (
                    <SignIn onSwitchToSignUp={handleSwitchToSignUp} />
                ) : (
                    <SignUp onSwitchToSignIn={handleSwitchToSignIn} />
                )}
            </Box>
        </Box>
    );
};

export default AuthPage; 